import React from "react";
import { SimpleHeader } from "./SimpleHeader";

interface ContactHeaderProps {
  contact: server.dto.Contact
}

export const ContactHeader = ({ contact }: ContactHeaderProps) =>
  <SimpleHeader title={contact.name.fullName} isDeleted={contact.isDeleted}>
    {contact.position
      ? <div className="purple-header-text">{contact.position}</div>
      : <div className="purple-header-text purple-header-light">{RESX.Contact.NoPositionSet}</div>}
  </SimpleHeader>;
